import { FormViewField } from 'components/FormView';
export default {
  formName: 'CustomerQuoteEnquiryFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'EX_LOOKUP_FIELD',
      visible: true,
      props: {
        label: 'Entity view',
        name: 'EntityView',
        size: 'small',
        lookupName: 'EntityView',
        required: true,
      }
    },
    {
      id: 2,
      type: 'EX_LOOKUP_FIELD',
      visible: true,
      props: {
        label: 'Sales entity',
        name: 'SalesEntity',
        lookupName: 'SalesEntity',
        size: 'small',
        suppressDescription: true,
      }
    },
    {
      id: 3,
      type: 'TEXT_FIELD',
      props: {
        label: 'Description',
        name: 'Description',
        placeholder: '',
        size: 'large',
        inputProps: {
          maxLength: 40
        }
      }
    },
    {
      id: 4,
      type: 'AUTOCOMPLETE_FIELD',
      props: {
        label: 'Status',
        name: 'Status',
        required: false,
        apiPrefs: {
          path: '/CustomTypes/Lookup/CustomerQuoteStatus',
          method: 'GET',
          params: {
            BatchSize: 20
          }
        },
      }
    },
    {
      id: 5,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Customer',
        name: 'CustomerId',
        lookupName: 'Customer',
        placeholder: '',
        required: false,
        size: 'medium',
        searchScreenAPIParms: { Type: 'LOOKUP' }
      }
    },
    {
      id: 6,
      type: 'SELECT_FIELD',
      props: {
        label: 'Finalised/Unfinalised',
        name: 'Finalised',
        defaultValue: 'False',
        options: [
          {
            value: 'False',
            label: 'Unfinalised',
            default: true
          },
          {
            value: 'True',
            label: 'Finalised'
          }
        ]
      }
    },
    {
      id: 7,
      type: 'DATE_FIELD',
      props: {
        label: 'From',
        name: 'FromDate',
        required: false,
        dateFormat: 'DD/MM/YYYY',
        placeholder: 'DD/MM/YYYY',
        nullable: 'true',
        size: 'medium',
        style: {
          display: 'inline-block',
          width: '155px',
          marginRight: '16px'
        }
      }
    },
    {
      id: 8,
      type: 'DATE_FIELD',
      props: {
        label: 'To',
        name: 'ToDate',
        required: false,
        dateFormat: 'DD/MM/YYYY',
        placeholder: 'DD/MM/YYYY',
        nullable: 'true',
        size: 'medium',
        style: {
          display: 'inline-block',
          width: '155px'
        }
      }
    },
  ] as FormViewField[]
};
